<app-power-bi-input [reportInput]="powerBIConfig"></app-power-bi-input>
